import { Component, input } from '@angular/core';
import { IBlogPost } from '../../../blog/_prismic/blog-post';
import { RouterLink } from '@angular/router';
import { UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-blog-card',
    templateUrl: './blog-card.component.html',
    styleUrls: ['./blog-card.component.scss'],
    imports: [RouterLink, UpperCasePipe, DatePipe]
})
export class BlogCardComponent {
  public readonly blogPost = input.required<IBlogPost>();

  constructor() { }

}
